import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import { EMPTY_VALUE } from "Common/componentUtils/constants";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import values from "lodash/values";
import { NAV_ITEM_DISABLED_CLASS_NAME, SidebarMenuItem } from "../../Common";
export const buildDocumentObjectKey = (objId) => `documentObject_${objId}`;
export default (documentObjects, draggableType, readOnlyMode) => map(groupBy(values(documentObjects), o => o.GroupName || EMPTY_VALUE), (items, groupName) => {
    const groupItem = new SidebarMenuItem(groupName, groupName, undefined, undefined, undefined, map(items, o => {
        const e = new SidebarMenuItem(buildDocumentObjectKey(o.Id), o.Name, o.IconId ? documentObjectIconMap[o.IconId] : undefined, undefined, o);
        if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
            e.className = NAV_ITEM_DISABLED_CLASS_NAME;
        }
        else {
            e.draggableType = draggableType;
            e.draggableData = JSON.stringify(o);
        }
        return e;
    }));
    if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
        groupItem.className = NAV_ITEM_DISABLED_CLASS_NAME;
    }
    return groupItem;
});
